class ESACustomWidget extends HTMLElement {
  constructor() {
    super();

    this.quantity = 1;
    this.addonVariantId = this.dataset.variantId;
  }

  connectedCallback() {
    this.sellingPlanInput = this.querySelector('#esa__selling-plan');
    this.purchaseRadios = this.querySelectorAll('input[name="purchase_option"]');

    this.bindEvents();
    this.bindAddToCartButtons();
  }

  bindEvents() {
    this.purchaseRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = radio.value;
        }
      });
    });
  }

  bindAddToCartButtons() {
    const buttons = document.querySelectorAll('.product-actions__add-to-cart-button');

    buttons.forEach(button => {
      button.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const form = button.closest('form');

        if (!form) return;

        button.disabled = true;
        button.classList.add('adding');

        const text = button.querySelector('.js-product-add-to-cart-button-text');

        if (text) {
          text.textContent = 'Adding to cart...';
        }

        this.handleAddToCart(form, button);
      });
    });
  }

  handleAddToCart(form, button) {
    const formData = new FormData(form);

    const mainVariantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity') || 1);

    const sellingPlanId = this.sellingPlanInput?.value;

    if (!mainVariantId) {
      this.resetButton(button);
      return;
    }

    const items = [
      {
        id: Number(mainVariantId),
        quantity
      },
      {
        id: Number(this.addonVariantId),
        quantity: this.quantity,
        parent_id: Number(mainVariantId),
        selling_plan: Number(sellingPlanId)
      }
    ];

    this.addMultipleItems(items, button);
  }

  addMultipleItems(items, button) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then(response => response.json())
      .then(response => {
        console.log('Items added:', response);

        this.resetButton(button);

        window.location.href = '/cart';
      })
      .catch(error => {
        console.error(error);

        this.resetButton(button);
      });
  }

  resetButton(button) {
    button.disabled = false;
    button.classList.remove('adding');

    const text = button.querySelector(
      '.js-product-add-to-cart-button-text'
    );

    if (text) {
      text.textContent = 'Add to cart';
    }
  }
}

customElements.define('esa-custom-widget', ESACustomWidget);